import { cn } from "@/lib/cn";

export const RadioSelect = ({
  label,
  options,
  selected,
  setSelected,
}: {
  label: string;
  selected: unknown;
  options: { title: string; value: string | number }[];
  setSelected: (value: string | number) => void;
}) => {
  return (
    <div className="tw-flex tw-w-full tw-items-center tw-justify-between">
      <span className="tw-font-sans tw-text-[13px]/normal tw-font-semibold tw-text-blue-base">
        {label}
      </span>
      <div className="tw-flex tw-items-center tw-gap-6">
        {options.map((option) => (
          <span
            className="tw-flex tw-cursor-pointer tw-items-center tw-font-sans tw-text-[13px]/normal tw-font-normal tw-text-blue-base"
            onClick={() => setSelected(option.value)}
            key={option.value}
          >
            <span
              className={cn(
                "tw-mr-2 tw-block tw-size-4 tw-rounded-full tw-border-2 tw-border-solid tw-border-blue-100",
                {
                  "tw-border-[5px] tw-border-primary-base":
                    selected === option.value,
                },
              )}
            ></span>
            {option.title}
          </span>
        ))}
      </div>
    </div>
  );
};
